/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COMMITTE_LIST = gql`
  query GetAllCommitteInviteStatus($filter: CommitteFilterInput) {
    getAllCommitteInviteStatus(filter: $filter) {
      count
      limit
      skip
      content {
        id
        user {
          id
          firstName
          lastName
          email
          role {
            name
            uuid
            state
          }
        }
        maxInvites
        inviteUsed
        partition
        presentation {
          id
          name
        }
        sectionOptType
        sections {
          id
          name
        }
        purchased
      }
    }
  }
`;
